module.exports = __webpack_public_path__ + "static/media/adulticon.71e3d85e.svg";